export default __webpack_public_path__ + "static/media/Lynda-Meichtry.6d75d523.jpg";